module.exports = __webpack_public_path__ + "static/1179463668.b8e52fd8.jpg";